import { IkeFieldType } from '@ikegps/core-api';
import { type CollectionModel, CollectionModelFieldSubForm, CollectionModelFieldTrueSize } from '@ikegps/core-shared';
import { T, Translate } from '../../../i18n';
import { AppStore } from '../../../store';
import type { BaseReportComponent } from '../components/BaseReportComponent';
import { DataGrid } from '../components/DataGrid';
import { ImageWithTitle } from '../components/ImageWithTitle';
import { SPLIT_VIEW_COLUMN_GAP, SplitView } from '../components/SplitView';
import { TitleBar } from '../components/TitleBar';
import { DataExtractor } from '../DataExtractor';
import { pdfTheme } from '../pdfTheme';
import {
	captureReferenceString,
	compositeURL,
	extractSubforms,
	hasUserMeasurement,
	isCaptureHidden,
} from '../ReportHelpers';
import { ReportBase } from './ReportBase';

export class ReportShort extends ReportBase {
	constructor(poles: CollectionModel[]) {
		super(poles);
	}

	buildPDF(): void {
		const singleColumnWidth = (pdfTheme.page.width - SPLIT_VIEW_COLUMN_GAP) / 2;

		this.poles.forEach((pole, i) => {
			const job = AppStore.Tag.get(pole.jobId);
			const fullImages: [string, string][] = [];
			const fieldNodes: BaseReportComponent[] = [];
			const tagArr: [string, string][] = [];
			const leftPanel: BaseReportComponent[] = [];
			const rightPanel: BaseReportComponent[] = [];

			this.nodes.push(
				new TitleBar(
					pole.title || Translate(T.COLLECTION_MISSING_TITLE),
					job.name,
					i + 1,
					this.poles.length,
					i === 0 ? 'none' : 'before'
				)
			);

			rightPanel.push(new DataGrid(tagArr, 2));

			// Data grid of items outside of sub forms
			pole.forEachField((field) => {
				if (field.parent.parent == null) {
					if (
						field.hasValue() &&
						field.schema.type !== IkeFieldType.FORM &&
						field.schema.type !== IkeFieldType.IMAGE &&
						field.schema.type !== IkeFieldType.TRUE_SIZE
					) {
						const extractedValue = DataExtractor.createPrintableValue(field);
						tagArr.push([extractedValue.title, extractedValue.value]);
					}

					if (field instanceof CollectionModelFieldSubForm) {
						fieldNodes.push(...extractSubforms(pole, field, this.images, 2));
					}

					if (field instanceof CollectionModelFieldTrueSize) {
						const captures = field.getCaptures();
						captures.forEach((capture) => {
							if (!isCaptureHidden(pole, capture.objectId)) {
								if (hasUserMeasurement(pole, capture.objectId)) {
									const imageReferenceString = captureReferenceString(pole, capture);
									this.images[imageReferenceString] = compositeURL(pole, capture);
									fullImages.push([field.schema.displayName, imageReferenceString]);
								}
							}
						});
					}
				}
			});

			if (fullImages[0]) {
				leftPanel.push(
					new ImageWithTitle(fullImages[0][0], { reference: fullImages[0][1] }, { width: singleColumnWidth })
				);
			}

			fieldNodes.forEach((fieldNode, j) => {
				if (j % 2 === 0) {
					leftPanel.push(fieldNode);
				} else {
					rightPanel.push(fieldNode);
				}
			});

			this.nodes.push(new SplitView(leftPanel, rightPanel));
		});
	}
}
